import moment from "moment";
import * as constantsManager from "../../services/managers/constants";
import securityManager from "../../services/managers/security";

// Initial State
const state = {
  // List of Products in the Filters section
  products: [],
  // Selected Product Code in the Filters section
  selectedProduct: constantsManager.SELECT_EMPTY_VALUE,
  // Start Date selected in the Filters section
  selectedDateRangeFrom: moment()
    .subtract(1, "days")
    .subtract(1, "months")
    .unix(),
  // End Date selected in the Filters section
  selectedDateRangeTo: moment()
    .subtract(1, "days")
    .unix(),
  // List of Trading Hours in the Filters section
  tradingHours: constantsManager.TRADING_HOURS,
  // Selected Trading Hour in the Filters section
  selectedTradingHour: constantsManager.TRADING_HOUR_REGULAR,
  // List of Zones in the Filters section
  zones: constantsManager.ZONES,
  // Selected Zone in the Filters section
  selectedZone: constantsManager.ZONE_CH,
  // List of CTT Lot Sizes mapped to selected Product
  costToTradeLotSizes: [],
  // Multiple Whiteboards for side-by-side charts comparison, maximum of 2
  chartWhiteboards: [
    { ...constantsManager.WHITEBOARD_INITIAL_STATE, __id: securityManager.generateKey(), __change_detection_key: securityManager.generateKey() }
  ]
};

export default state;



// WEBPACK FOOTER //
// ./src/store/analytics/state.js